import { __decorate } from 'tslib';
import { CommonModule } from '@angular/common';
import { Input, Component, ChangeDetectorRef, ViewEncapsulation, ChangeDetectionStrategy, EventEmitter, Output, Pipe, NgModule } from '@angular/core';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';

const _c0 = function (a0, a1) { return [a0, a1]; };
const _c1 = ["*"];
function LayoutComponent_div_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function LayoutComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 7);
    ɵngcc0.ɵɵlistener("mouseenter", function LayoutComponent_div_1_Template_div_mouseenter_0_listener() { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.leftContainerMouseEnter(); })("mouseleave", function LayoutComponent_div_1_Template_div_mouseleave_0_listener() { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.leftContainerMouseLeave(); });
    ɵngcc0.ɵɵelementStart(1, "div", 8);
    ɵngcc0.ɵɵtemplate(2, LayoutComponent_div_1_ng_container_2_Template, 1, 0, "ng-container", 3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r0.leftTemplate);
} }
function LayoutComponent_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function LayoutComponent_div_4_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function LayoutComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 9);
    ɵngcc0.ɵɵlistener("mouseenter", function LayoutComponent_div_4_Template_div_mouseenter_0_listener() { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r10 = ɵngcc0.ɵɵnextContext(); return ctx_r10.rightContainerMouseEnter(); })("mouseleave", function LayoutComponent_div_4_Template_div_mouseleave_0_listener() { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r12 = ɵngcc0.ɵɵnextContext(); return ctx_r12.rightContainerMouseLeave(); });
    ɵngcc0.ɵɵelementStart(1, "div", 10);
    ɵngcc0.ɵɵtemplate(2, LayoutComponent_div_4_ng_container_2_Template, 1, 0, "ng-container", 3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r2.rightTemplate);
} }
function LayoutComponent_ng_template_6_div_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function LayoutComponent_ng_template_6_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 14);
    ɵngcc0.ɵɵtemplate(1, LayoutComponent_ng_template_6_div_0_ng_container_1_Template, 1, 0, "ng-container", 3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r13 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r13.topTemplate);
} }
function LayoutComponent_ng_template_6_div_3_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function LayoutComponent_ng_template_6_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 15);
    ɵngcc0.ɵɵtemplate(1, LayoutComponent_ng_template_6_div_3_ng_container_1_Template, 1, 0, "ng-container", 3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r14 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r14.bottomTemplate);
} }
function LayoutComponent_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, LayoutComponent_ng_template_6_div_0_Template, 2, 1, "div", 11);
    ɵngcc0.ɵɵelementStart(1, "div", 12);
    ɵngcc0.ɵɵprojection(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(3, LayoutComponent_ng_template_6_div_3_Template, 2, 1, "div", 13);
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.topTemplate);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.bottomTemplate);
} }
function NavMenuItemComponent_ng_container_0_ng_container_1_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function NavMenuItemComponent_ng_container_0_ng_container_1_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelement(1, "ui-ng-nav-menu-item", 9);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const child_r10 = ctx.$implicit;
    const ctx_r9 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("item", child_r10)("filterValue", ctx_r9.filterValue)("expandAll", ctx_r9.expandAll);
} }
function NavMenuItemComponent_ng_container_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "li", 4);
    ɵngcc0.ɵɵelementStart(2, "a", 5);
    ɵngcc0.ɵɵlistener("click", function NavMenuItemComponent_ng_container_0_ng_container_1_Template_a_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r11 = ɵngcc0.ɵɵnextContext(2); return ctx_r11.toggle(); });
    ɵngcc0.ɵɵtemplate(3, NavMenuItemComponent_ng_container_0_ng_container_1_ng_container_3_Template, 1, 0, "ng-container", 6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "ul", 7);
    ɵngcc0.ɵɵtemplate(5, NavMenuItemComponent_ng_container_0_ng_container_1_ng_container_5_Template, 2, 3, "ng-container", 8);
    ɵngcc0.ɵɵpipe(6, "uiNgNavMenuFilter");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵnextContext();
    const _r6 = ɵngcc0.ɵɵreference(5);
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassProp("open", ctx_r3.isOpen || ctx_r3.expandAll);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r6);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", !ctx_r3.isOpen && !ctx_r3.expandAll);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ɵngcc0.ɵɵpipeBind2(6, 5, ctx_r3.item.children, ctx_r3.filterValue));
} }
function NavMenuItemComponent_ng_container_0_ng_template_2_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function NavMenuItemComponent_ng_container_0_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li", 4);
    ɵngcc0.ɵɵelementStart(1, "a", 10);
    ɵngcc0.ɵɵtemplate(2, NavMenuItemComponent_ng_container_0_ng_template_2_ng_container_2_Template, 1, 0, "ng-container", 6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵnextContext();
    const _r6 = ɵngcc0.ɵɵreference(5);
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassProp("active", ctx_r5.item.isActive);
    ɵngcc0.ɵɵproperty("href", ctx_r5.item.href, ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r6);
} }
function NavMenuItemComponent_ng_container_0_ng_template_4_i_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 13);
} if (rf & 2) {
    const ctx_r14 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r14.item.icon);
} }
function NavMenuItemComponent_ng_container_0_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, NavMenuItemComponent_ng_container_0_ng_template_4_i_0_Template, 1, 1, "i", 11);
    ɵngcc0.ɵɵelementStart(1, "span", 12);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r7.item.icon);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r7.item.name);
} }
function NavMenuItemComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, NavMenuItemComponent_ng_container_0_ng_container_1_Template, 7, 8, "ng-container", 0);
    ɵngcc0.ɵɵtemplate(2, NavMenuItemComponent_ng_container_0_ng_template_2_Template, 3, 4, "ng-template", null, 2, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵtemplate(4, NavMenuItemComponent_ng_container_0_ng_template_4_Template, 3, 2, "ng-template", null, 3, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r4 = ɵngcc0.ɵɵreference(3);
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.item.children == null ? null : ctx_r0.item.children.length)("ngIfElse", _r4);
} }
function NavMenuItemComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li", 14);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r2.item.name);
} }
function NavMenuComponent_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "ui-ng-nav-menu-item", 5);
    ɵngcc0.ɵɵlistener("setOpenId", function NavMenuComponent_ng_container_5_Template_ui_ng_nav_menu_item_setOpenId_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.setOpenedId($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r1 = ctx.$implicit;
    const i_r2 = ctx.index;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("item", item_r1)("id", i_r2 + 1)("openedId", ctx_r0.openedId)("filterValue", ctx_r0.filterValue)("expandAll", ctx_r0.expandAll);
} }
const _c2 = function (a0, a1, a2, a3) { return { "sidebar-mini": a0, show: a1, "sidebar-fixed": a2, "sidebar-collapsed": a3 }; };
let ImageOverlayComponent = class ImageOverlayComponent {
    constructor() {
        /**
         * Image Name
         */
        this.imgName = 'image';
        /**
         * Image Overlay Background Color
         */
        this.imgOverlayBgColor = 'primary-dark';
    }
};
ImageOverlayComponent.ɵfac = function ImageOverlayComponent_Factory(t) { return new (t || ImageOverlayComponent)(); };
ImageOverlayComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ImageOverlayComponent, selectors: [["ui-ng-image-overlay"]], inputs: { imgName: "imgName", imgOverlayBgColor: "imgOverlayBgColor", imgSrc: "imgSrc", imgAnimation: "imgAnimation", imgOverlayAnimation: "imgOverlayAnimation" }, ngContentSelectors: _c1, decls: 5, vars: 7, consts: [[1, "img-container", 3, "ngClass"], [1, "img-fluid", "img-item", 3, "src", "alt"], [1, "img-overlay", 3, "ngClass"], [1, "img-overlay-content"]], template: function ImageOverlayComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelement(1, "img", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵprojection(4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(4, _c0, "img-" + ctx.imgAnimation, "img-overlay-" + ctx.imgOverlayAnimation));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("src", ctx.imgSrc, ɵngcc0.ɵɵsanitizeUrl)("alt", ctx.imgName);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", "img-overlay-" + ctx.imgOverlayBgColor);
    } }, directives: [ɵngcc1.NgClass], styles: ["[_nghost-%COMP%]{display:block}.img-container[_ngcontent-%COMP%]{position:relative;z-index:1;display:inline-block;overflow:hidden}.img-container[_ngcontent-%COMP%]   .img-item[_ngcontent-%COMP%]{transition:transform .25s ease-out;will-change:transform}.img-container[_ngcontent-%COMP%]   .img-overlay[_ngcontent-%COMP%]{position:absolute;top:-.2rem;right:0;bottom:-.2rem;left:0;z-index:2;display:flex;align-items:center;justify-content:center;visibility:hidden;opacity:0;transition:.3s ease-in;will-change:opacity,transform}.img-container[_ngcontent-%COMP%]   .img-overlay-content[_ngcontent-%COMP%]{text-align:center}.img-container[_ngcontent-%COMP%]   .img-overlay-black[_ngcontent-%COMP%]{background-color:rgba(0,0,0,.75)}.img-container[_ngcontent-%COMP%]   .img-overlay-white[_ngcontent-%COMP%]{background-color:rgba(255,255,255,.9)}.img-container[_ngcontent-%COMP%]   .img-overlay-primary-dark[_ngcontent-%COMP%]{background-color:rgba(62,74,89,.8)}.img-overlay-slide-top[_ngcontent-%COMP%]   .img-overlay[_ngcontent-%COMP%]{transform:translateY(100%)}.img-overlay-slide-right[_ngcontent-%COMP%]   .img-overlay[_ngcontent-%COMP%]{transform:translateX(-100%)}.img-overlay-slide-down[_ngcontent-%COMP%]   .img-overlay[_ngcontent-%COMP%]{transform:translateY(-100%)}.img-overlay-slide-left[_ngcontent-%COMP%]   .img-overlay[_ngcontent-%COMP%]{transform:translateX(100%)}.img-overlay-zoom-in[_ngcontent-%COMP%]   .img-overlay[_ngcontent-%COMP%]{transform:scale(0,0)}.img-overlay-zoom-out[_ngcontent-%COMP%]   .img-overlay[_ngcontent-%COMP%]{transform:scale(2,2)}.img-overlay-slide-top[_ngcontent-%COMP%]:hover   .img-overlay[_ngcontent-%COMP%]{transform:translateY(0)}.img-overlay-slide-right[_ngcontent-%COMP%]:hover   .img-overlay[_ngcontent-%COMP%]{transform:translateX(0)}.img-overlay-slide-down[_ngcontent-%COMP%]:hover   .img-overlay[_ngcontent-%COMP%]{transform:translateY(0)}.img-overlay-slide-left[_ngcontent-%COMP%]:hover   .img-overlay[_ngcontent-%COMP%]{transform:translateX(0)}.img-overlay-zoom-in[_ngcontent-%COMP%]:hover   .img-overlay[_ngcontent-%COMP%], .img-overlay-zoom-out[_ngcontent-%COMP%]:hover   .img-overlay[_ngcontent-%COMP%]{transform:scale(1,1)}.img-zoom-in[_ngcontent-%COMP%]:hover   .img-item[_ngcontent-%COMP%]{transform:scale(1.2,1.2)}.img-rotate-r[_ngcontent-%COMP%]:hover   .img-item[_ngcontent-%COMP%]{transform:scale(1.4) rotate(8deg)}.img-rotate-l[_ngcontent-%COMP%]:hover   .img-item[_ngcontent-%COMP%]{transform:scale(1.4) rotate(-8deg)}.img-container[_ngcontent-%COMP%]:hover   .img-overlay[_ngcontent-%COMP%]{visibility:visible;opacity:1}.img-fluid[_ngcontent-%COMP%]{max-width:100%;height:auto}img[_ngcontent-%COMP%]{vertical-align:middle;border-style:none}"] });
__decorate([
    Input()
], ImageOverlayComponent.prototype, "imgName", void 0);
__decorate([
    Input()
], ImageOverlayComponent.prototype, "imgSrc", void 0);
__decorate([
    Input()
], ImageOverlayComponent.prototype, "imgAnimation", void 0);
__decorate([
    Input()
], ImageOverlayComponent.prototype, "imgOverlayAnimation", void 0);
__decorate([
    Input()
], ImageOverlayComponent.prototype, "imgOverlayBgColor", void 0);

/**
 * Options for Right and Left containers in Layout
 */
var layoutPanelPosition;
(function (layoutPanelPosition) {
    layoutPanelPosition["Default"] = "Default";
    layoutPanelPosition["Fixed"] = "Fixed";
    layoutPanelPosition["Hidden"] = "Hidden";
    layoutPanelPosition["Hover"] = "Hover";
})(layoutPanelPosition || (layoutPanelPosition = {}));

let LayoutComponent = class LayoutComponent {
    constructor(ref) {
        this.ref = ref;
        /**
         * Layout Config: LayoutConfig
         */
        this.config = {
            fixedTopContainer: false,
            rightContainerPosition: layoutPanelPosition.Default,
            leftContainerPosition: layoutPanelPosition.Default,
            toggleLeftAndRightPosition: false,
            fullWidthOnSmallScreen: false,
            shiftLeftContentWithHoverMode: false,
            shiftRightContentWithHoverMode: false,
        };
        /**
         * SimpleBar Options
         */
        this.scrollBarOptions = { autoHide: true, scrollbarMinSize: 100 };
        /**
         * open left container if fixed
         */
        this.isLeftOpened = false;
        /**
         * open right container if fixed
         */
        this.isRightOpened = false;
        /**
         * open right container if less than 991.98px
         */
        this.isRightXsOpened = false;
        /**
         * open left container if less than 991.98px
         */
        this.isLeftXsOpened = false;
        /**
         * layout positions
         */
        this.layoutPosition = layoutPanelPosition;
        /**
         * Show Overlay: boolean
         */
        this.showOverlay = false;
        /**
         * Left container hovered
         */
        this.leftContainerHovered = false;
        /**
         * Right container hovered
         */
        this.rightContainerHovered = false;
    }
    /**
     * Hide overlay
     */
    closeContainer() {
        this.showOverlay = false;
        this.isRightOpened = false;
        this.isLeftOpened = false;
        this.isRightXsOpened = false;
        this.isLeftXsOpened = false;
        this.ref.markForCheck();
    }
    /**
     * Show right container
     * @param withOverlay :boolean - show overlay
     */
    showRightContainer(withOverlay = false) {
        if (this.config.fullWidthOnSmallScreen &&
            window.innerWidth <= 991.98 &&
            this.config.rightContainerPosition &&
            this.config.rightContainerPosition !== layoutPanelPosition.Default) {
            this.showOverlay = withOverlay;
            this.isRightXsOpened = true;
            this.isRightOpened = true;
        }
        else if (this.config.rightContainerPosition &&
            this.config.rightContainerPosition === layoutPanelPosition.Hidden) {
            this.showOverlay = withOverlay;
            this.isRightOpened = true;
        }
        this.ref.markForCheck();
    }
    /**
     * Show left container
     * @param withOverlay :boolean - show overlay
     */
    showLeftContainer(withOverlay = false) {
        if (this.config.fullWidthOnSmallScreen &&
            window.innerWidth <= 991.98 &&
            this.config.leftContainerPosition &&
            this.config.leftContainerPosition !== layoutPanelPosition.Default) {
            this.showOverlay = withOverlay;
            this.isLeftXsOpened = true;
            this.isLeftOpened = true;
        }
        else if (this.config.leftContainerPosition &&
            this.config.leftContainerPosition === layoutPanelPosition.Hidden) {
            this.showOverlay = withOverlay;
            this.isLeftOpened = true;
        }
        this.ref.markForCheck();
    }
    /**
     * Left container mouse enter
     */
    leftContainerMouseEnter() {
        this.leftContainerHovered = true;
    }
    /**
     * Left Container mouse leave
     */
    leftContainerMouseLeave() {
        this.leftContainerHovered = false;
    }
    /**
     * Right container mouse enter
     */
    rightContainerMouseEnter() {
        this.rightContainerHovered = true;
    }
    /**
     * Right container mouse leave
     */
    rightContainerMouseLeave() {
        this.rightContainerHovered = false;
    }
    /**
     * Can minimize left container content when Hover collapsed
     */
    get leftHoverMinimizedContent() {
        return (this.config.leftContainerPosition === layoutPanelPosition.Hover &&
            this.config.shiftLeftContentWithHoverMode &&
            !this.leftContainerHovered &&
            !(window.innerWidth <= 991.98));
    }
    /**
     * Can minimize right container content when Hover collapsed
     */
    get rightHoverMinimizedContent() {
        return (this.config.rightContainerPosition === layoutPanelPosition.Hover &&
            this.config.shiftRightContentWithHoverMode &&
            !this.rightContainerHovered &&
            !(window.innerWidth <= 991.98));
    }
    /**
     * Layout component wrapper classNames
     */
    get layoutContainerClass() {
        return {
            'switch-side-containers': (this.config.toggleLeftAndRightPosition &&
                this.config.rightContainerPosition !==
                    layoutPanelPosition.Default &&
                this.config.leftContainerPosition !==
                    layoutPanelPosition.Default) ||
                (this.config.toggleLeftAndRightPosition &&
                    !this.leftTemplate &&
                    this.rightTemplate &&
                    this.config.rightContainerPosition !==
                        layoutPanelPosition.Default) ||
                (this.config.toggleLeftAndRightPosition &&
                    !this.rightTemplate &&
                    this.leftTemplate &&
                    this.config.leftContainerPosition !==
                        layoutPanelPosition.Default),
            'show-overlay': this.showOverlay,
            'left-fixed': this.config.leftContainerPosition === layoutPanelPosition.Fixed,
            'left-hidden': this.config.leftContainerPosition ===
                layoutPanelPosition.Hidden,
            'left-opened': this.config.leftContainerPosition ===
                layoutPanelPosition.Hidden && this.isLeftOpened,
            'left-opened-xs': this.isLeftXsOpened,
            'left-hover': this.config.leftContainerPosition === layoutPanelPosition.Hover,
            'left-shift-content': this.leftHoverMinimizedContent &&
                (!this.config.toggleLeftAndRightPosition ||
                    (this.config.toggleLeftAndRightPosition &&
                        this.config.rightContainerPosition ===
                            layoutPanelPosition.Default)),
            'right-fixed': this.config.rightContainerPosition ===
                layoutPanelPosition.Fixed,
            'right-hidden': this.config.rightContainerPosition ===
                layoutPanelPosition.Hidden,
            'right-opened': this.config.rightContainerPosition ===
                layoutPanelPosition.Hidden && this.isRightOpened,
            'right-opened-xs': this.isRightXsOpened,
            'right-hover': this.config.rightContainerPosition ===
                layoutPanelPosition.Hover,
            'right-shift-content': this.rightHoverMinimizedContent &&
                (this.config.toggleLeftAndRightPosition ||
                    (!this.config.toggleLeftAndRightPosition &&
                        this.config.leftContainerPosition ===
                            layoutPanelPosition.Default)),
            'top-fixed': this.config.fixedTopContainer,
            'fixed-full-screen-on-small-resolution': this.config
                .fullWidthOnSmallScreen,
        };
    }
};
LayoutComponent.ɵfac = function LayoutComponent_Factory(t) { return new (t || LayoutComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
LayoutComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: LayoutComponent, selectors: [["ui-ng-layout"]], inputs: { config: "config", scrollBarOptions: "scrollBarOptions", topTemplate: "topTemplate", leftTemplate: "leftTemplate", rightTemplate: "rightTemplate", bottomTemplate: "bottomTemplate" }, ngContentSelectors: _c1, decls: 8, vars: 4, consts: [[1, "layout-page-wrap", 3, "ngClass"], ["class", "layout-left-container", 3, "mouseenter", "mouseleave", 4, "ngIf"], [1, "layout-central-container"], [4, "ngTemplateOutlet"], ["class", "layout-right-container", 3, "mouseenter", "mouseleave", 4, "ngIf"], [1, "layout-page-overlay", 3, "click"], ["centralContent", ""], [1, "layout-left-container", 3, "mouseenter", "mouseleave"], [1, "layout-left-container-content"], [1, "layout-right-container", 3, "mouseenter", "mouseleave"], [1, "layout-right-container-content"], ["class", "layout-top-container", 4, "ngIf"], [1, "layout-main-container"], ["class", "layout-bottom-container", 4, "ngIf"], [1, "layout-top-container"], [1, "layout-bottom-container"]], template: function LayoutComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, LayoutComponent_div_1_Template, 3, 1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵtemplate(3, LayoutComponent_ng_container_3_Template, 1, 0, "ng-container", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(4, LayoutComponent_div_4_Template, 3, 1, "div", 4);
        ɵngcc0.ɵɵelementStart(5, "div", 5);
        ɵngcc0.ɵɵlistener("click", function LayoutComponent_Template_div_click_5_listener() { return ctx.closeContainer(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(6, LayoutComponent_ng_template_6_Template, 4, 2, "ng-template", null, 6, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r3 = ɵngcc0.ɵɵreference(7);
        ɵngcc0.ɵɵproperty("ngClass", ctx.layoutContainerClass);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.leftTemplate);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r3);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.rightTemplate);
    } }, directives: [ɵngcc1.NgClass, ɵngcc1.NgIf, ɵngcc1.NgTemplateOutlet], styles: [""], encapsulation: 2, changeDetection: 0 });
LayoutComponent.ctorParameters = () => [
    { type: ChangeDetectorRef }
];
__decorate([
    Input()
], LayoutComponent.prototype, "config", void 0);
__decorate([
    Input()
], LayoutComponent.prototype, "topTemplate", void 0);
__decorate([
    Input()
], LayoutComponent.prototype, "leftTemplate", void 0);
__decorate([
    Input()
], LayoutComponent.prototype, "rightTemplate", void 0);
__decorate([
    Input()
], LayoutComponent.prototype, "bottomTemplate", void 0);
__decorate([
    Input()
], LayoutComponent.prototype, "scrollBarOptions", void 0);

let NavMenuItemComponent = class NavMenuItemComponent {
    constructor() {
        /**
         * Sets top-level menu item id
         */
        this.setOpenId = new EventEmitter();
    }
    /**
     * Updates menu item open state based on its id / owing of active item
     */
    ngOnChanges(changes) {
        if (changes.item) {
            this.isOpen = this.item.children
                ? this.hasActiveChild(this.item)
                : false;
        }
        else if (this.id && changes.openedId) {
            this.isOpen = this.id === this.openedId;
        }
    }
    /**
     * Toggles nav menu item state - open/close
     */
    toggle() {
        this.isOpen = !this.isOpen;
        if (this.id) {
            this.isOpen
                ? this.setOpenId.emit(this.id)
                : this.setOpenId.emit(null);
        }
    }
    /**
     * Checks if among menu items children is an active one
     */
    hasActiveChild(item) {
        let result;
        if (item.children) {
            result = item.children.some((child) => this.hasActiveChild(child));
        }
        else {
            result = item.isActive;
        }
        return result;
    }
};
NavMenuItemComponent.ɵfac = function NavMenuItemComponent_Factory(t) { return new (t || NavMenuItemComponent)(); };
NavMenuItemComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NavMenuItemComponent, selectors: [["ui-ng-nav-menu-item"]], inputs: { item: "item", id: "id", openedId: "openedId", filterValue: "filterValue", expandAll: "expandAll" }, outputs: { setOpenId: "setOpenId" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 3, vars: 2, consts: [[4, "ngIf", "ngIfElse"], ["heading", ""], ["finalItem", ""], ["content", ""], [1, "nav-main-item"], [1, "nav-main-link", "nav-main-link-submenu", 3, "click"], [4, "ngTemplateOutlet"], [1, "nav-main-submenu", 3, "hidden"], [4, "ngFor", "ngForOf"], [3, "item", "filterValue", "expandAll"], [1, "nav-main-link", 3, "href"], ["class", "nav-main-link-icon", 3, "ngClass", 4, "ngIf"], [1, "nav-main-link-name"], [1, "nav-main-link-icon", 3, "ngClass"], [1, "nav-main-heading"]], template: function NavMenuItemComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, NavMenuItemComponent_ng_container_0_Template, 6, 2, "ng-container", 0);
        ɵngcc0.ɵɵtemplate(1, NavMenuItemComponent_ng_template_1_Template, 2, 1, "ng-template", null, 1, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = ɵngcc0.ɵɵreference(2);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.item.isHeading)("ngIfElse", _r1);
    } }, directives: function () { return [ɵngcc1.NgIf, ɵngcc1.NgTemplateOutlet, ɵngcc1.NgForOf, NavMenuItemComponent, ɵngcc1.NgClass]; }, pipes: function () { return [NavMenuFilterPipe]; }, styles: ["@charset \"UTF-8\";[_nghost-%COMP%]   *[_ngcontent-%COMP%], [_nghost-%COMP%]   [_ngcontent-%COMP%]:after, [_nghost-%COMP%]   [_ngcontent-%COMP%]:before{box-sizing:border-box}.nav-main-heading[_ngcontent-%COMP%]{padding:1.375rem 1.25rem .375rem;font-weight:600;font-size:.75rem;letter-spacing:.0625rem;text-transform:uppercase}.nav-main-item[_ngcontent-%COMP%]{display:flex;flex-direction:column}.nav-main-link[_ngcontent-%COMP%]{position:relative;display:flex;align-items:center;min-height:2.5rem;padding:.625rem 1.25rem;font-size:.875rem;line-height:1rem;text-decoration:none}.nav-main-link[_ngcontent-%COMP%]   .nav-main-link-icon[_ngcontent-%COMP%]{display:inline-block;flex:0 0 auto;width:1rem;margin-right:.625rem;text-align:center}.nav-main-link[_ngcontent-%COMP%]   .nav-main-link-name[_ngcontent-%COMP%]{display:inline-block;flex:1 1 auto;max-width:100%}.nav-main-link[_ngcontent-%COMP%]:hover{cursor:pointer}.nav-main-link.nav-main-link-submenu[_ngcontent-%COMP%]{padding-right:2rem}.nav-main-link.nav-main-link-submenu[_ngcontent-%COMP%]:before{position:absolute;top:50%;right:.625rem;display:block;width:1rem;height:1rem;margin-top:-.5rem;font-weight:900;font-size:.75rem;font-family:\"Font Awesome 5 Free\",\"Font Awesome 5 Pro\",serif;line-height:1rem;text-align:center;opacity:.4;transition:opacity .25s ease-out,transform .25s ease-out;content:\"\uF104\"}.nav-main-submenu[_ngcontent-%COMP%]{height:0;padding-left:2.875rem;overflow:hidden;list-style:none}.nav-main-submenu[_ngcontent-%COMP%]   .nav-main-item[_ngcontent-%COMP%]{transform:translateX(-.75rem);opacity:0;transition:opacity .25s ease-out,transform .25s ease-out}.nav-main-submenu[_ngcontent-%COMP%]   .nav-main-heading[_ngcontent-%COMP%]{padding-top:1.25rem;padding-bottom:.25rem;padding-left:0}.nav-main-submenu[_ngcontent-%COMP%]   .nav-main-link[_ngcontent-%COMP%]{min-height:2.125rem;margin:0;padding-top:.5rem;padding-bottom:.5rem;padding-left:0;font-size:.8125rem}.nav-main-submenu[_ngcontent-%COMP%]   .nav-main-link[_ngcontent-%COMP%]   .active[_ngcontent-%COMP%], .nav-main-submenu[_ngcontent-%COMP%]   .nav-main-link[_ngcontent-%COMP%]:hover{background-color:transparent}.nav-main-submenu[_ngcontent-%COMP%]   .nav-main-submenu[_ngcontent-%COMP%]{padding-left:.75rem}.nav-main-submenu[_ngcontent-%COMP%]   .nav-main-item.open[_ngcontent-%COMP%]   .nav-main-link[_ngcontent-%COMP%]{background-color:transparent}.nav-main-item.open[_ngcontent-%COMP%] > .nav-main-link-submenu[_ngcontent-%COMP%]:before{transform:rotate(-90deg)}.nav-main-item.open[_ngcontent-%COMP%] > .nav-main-submenu[_ngcontent-%COMP%]{height:auto}.nav-main-item.open[_ngcontent-%COMP%] > .nav-main-submenu[_ngcontent-%COMP%]   .nav-main-item[_ngcontent-%COMP%]{transform:translateX(0);opacity:1}"] });
__decorate([
    Input()
], NavMenuItemComponent.prototype, "item", void 0);
__decorate([
    Input()
], NavMenuItemComponent.prototype, "id", void 0);
__decorate([
    Input()
], NavMenuItemComponent.prototype, "openedId", void 0);
__decorate([
    Input()
], NavMenuItemComponent.prototype, "filterValue", void 0);
__decorate([
    Input()
], NavMenuItemComponent.prototype, "expandAll", void 0);
__decorate([
    Output()
], NavMenuItemComponent.prototype, "setOpenId", void 0);

/**
 * Main navigation component
 */
let NavMenuComponent = class NavMenuComponent {
    constructor() {
        /**
         * Nav Munu Items
         */
        this.items = [];
        /**
         * Nav Menu Theme
         */
        this.theme = 'dark';
        /**
         * Defines whether custom or default scrollbar should be used
         */
        this.customScrollbar = true;
        /**
         * Nav Menu Mini Mode Enabled (if shown only)
         */
        this.miniMode = true;
        /**
         * Defines menu position - fixed or default
         */
        this.isFixed = false;
        /**
         * Define is collapse (mini mode) triggered on
         */
        this.isMiniOnMouseLeave = false;
        /**
         * Search text to filter nav item by name
         */
        this.filterValue = '';
        /**
         * Defines if all menu items are expanded at a time (if filter is applied)
         */
        this.expandAll = false;
        /**
         * Defines if nav menu should be shown
         */
        this._show = true;
    }
    /**
     * Resets openedId if items change
     */
    ngOnChanges(changes) {
        if (changes.items) {
            this.openedId = null;
        }
        if (changes.filterValue) {
            this.expandAll = !!changes.filterValue.currentValue.trim();
        }
    }
    /**
     * Defines if nav menu is shown
     */
    isShown() {
        return this._show;
    }
    /**
     * Defines if nav menu's mini mode is enabled
     */
    isMiniModeEnabled() {
        return this.miniMode;
    }
    /**
     * Shows nav menu
     */
    show() {
        this._show = true;
    }
    /**
     * Hides nav menu
     */
    hide() {
        this._show = false;
    }
    /**
     * Toggles nav menu appearance
     */
    toggle() {
        this._show = !this._show;
    }
    /**
     * Sets index of opened menu item
     */
    setOpenedId(index) {
        this.openedId = index;
    }
};
NavMenuComponent.ɵfac = function NavMenuComponent_Factory(t) { return new (t || NavMenuComponent)(); };
NavMenuComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NavMenuComponent, selectors: [["ui-ng-nav-menu"]], inputs: { items: "items", theme: "theme", customScrollbar: "customScrollbar", miniMode: "miniMode", isFixed: "isFixed", isMiniOnMouseLeave: "isMiniOnMouseLeave", filterValue: "filterValue" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], ngContentSelectors: _c1, decls: 7, vars: 14, consts: [[3, "ngClass"], [1, "nav-menu-header"], [1, "nav-menu-content"], [1, "nav-main"], [4, "ngFor", "ngForOf"], [3, "item", "id", "openedId", "filterValue", "expandAll", "setOpenId"]], template: function NavMenuComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "nav", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵprojection(2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "div", 2);
        ɵngcc0.ɵɵelementStart(4, "ul", 3);
        ɵngcc0.ɵɵtemplate(5, NavMenuComponent_ng_container_5_Template, 2, 5, "ng-container", 4);
        ɵngcc0.ɵɵpipe(6, "uiNgNavMenuFilter");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassMapInterpolate2("sidebar sidebar-", ctx.theme, " custom-scrollbar-", ctx.customScrollbar ? ctx.theme : "", "");
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction4(9, _c2, ctx.isMiniModeEnabled(), ctx.isShown(), ctx.isFixed, ctx.isMiniOnMouseLeave));
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngForOf", ɵngcc0.ɵɵpipeBind2(6, 6, ctx.items, ctx.filterValue));
    } }, directives: function () { return [ɵngcc1.NgClass, ɵngcc1.NgForOf, NavMenuItemComponent]; }, pipes: function () { return [NavMenuFilterPipe]; }, styles: ["[_nghost-%COMP%]{width:100%;height:100%}[_nghost-%COMP%]   *[_ngcontent-%COMP%], [_nghost-%COMP%]   [_ngcontent-%COMP%]:after, [_nghost-%COMP%]   [_ngcontent-%COMP%]:before{box-sizing:border-box}.sidebar[_ngcontent-%COMP%]{width:0;height:100%;overflow-y:auto;border:none;box-shadow:none;transition:width .28s ease-out;will-change:width;-ms-scroll-chaining:none;overscroll-behavior:contain}.sidebar.sidebar-fixed[_ngcontent-%COMP%]{position:fixed;top:0;bottom:0;left:0;z-index:1032}.nav-menu-header[_ngcontent-%COMP%]{width:100%;margin:0 auto}.nav-menu-content[_ngcontent-%COMP%]{width:100%;margin:0 auto;padding:0 1.25rem 1.25rem;overflow-x:hidden}.nav-main[_ngcontent-%COMP%]{margin:0 -1.25rem;padding:0;list-style:none}.sidebar-dark[_ngcontent-%COMP%]{color:#ebebeb;background-color:#002b49}.sidebar-dark[_ngcontent-%COMP%]     .nav-main-heading{color:rgba(255,255,255,.4)}.sidebar-dark[_ngcontent-%COMP%]     .nav-main-link{color:rgba(255,255,255,.5)}.sidebar-dark[_ngcontent-%COMP%]     .nav-main-link .nav-main-link-icon{color:rgba(255,255,255,.2)}.sidebar-dark[_ngcontent-%COMP%]     .nav-main-link.active{color:#fff}.sidebar-dark[_ngcontent-%COMP%]     .nav-main-item.open>.nav-main-link-submenu{color:#fff}.sidebar-light[_ngcontent-%COMP%]{color:#575757;background-color:#fff}.sidebar-light[_ngcontent-%COMP%]     .nav-main-heading{color:#979797}.sidebar-light[_ngcontent-%COMP%]     .nav-main-link{color:#575757}.sidebar-light[_ngcontent-%COMP%]     .nav-main-link .nav-main-link-icon{color:#b0b0b0}.sidebar-light[_ngcontent-%COMP%]     .nav-main-link.active{color:#000}.sidebar-light[_ngcontent-%COMP%]     .nav-main-item.open>.nav-main-link-submenu{color:#000}.sidebar-dark[_ngcontent-%COMP%]     .nav-main-submenu{background-color:rgba(0,0,0,.15)}.sidebar-dark[_ngcontent-%COMP%]     .nav-main-submenu .nav-main-link{color:rgba(255,255,255,.4)}.sidebar-dark[_ngcontent-%COMP%]     .nav-main-submenu .nav-main-link.active{color:#fff}.sidebar-light[_ngcontent-%COMP%]     .nav-main-submenu{background-color:rgba(0,0,0,.02)}.sidebar-light[_ngcontent-%COMP%]     .nav-main-submenu .nav-main-link{color:#717171}.sidebar-light[_ngcontent-%COMP%]     .nav-main-submenu .nav-main-link.active{color:#000}.sidebar-dark[_ngcontent-%COMP%]     .nav-main-link.active .nav-main-link-icon{color:#fff}.sidebar-light[_ngcontent-%COMP%]     .nav-main-link.active .nav-main-link-icon{color:#000}.sidebar-dark[_ngcontent-%COMP%]     .nav-main-link:hover{background-color:rgba(0,0,0,.2)}.sidebar-dark[_ngcontent-%COMP%]     .nav-main-link:hover>.nav-main-link-icon{color:#fff}.sidebar-light[_ngcontent-%COMP%]     .nav-main-link:hover{color:#575757;background-color:#f9f9f9}.sidebar-light[_ngcontent-%COMP%]     .nav-main-link:hover>.nav-main-link-icon{color:#000}.sidebar-dark[_ngcontent-%COMP%]     .nav-main-submenu .nav-main-link:hover{color:#fff}.sidebar-light[_ngcontent-%COMP%]     .nav-main-submenu .nav-main-link:hover{color:#000}.sidebar-dark[_ngcontent-%COMP%]     .nav-main-item.open>.nav-main-link-submenu .nav-main-link-icon{color:#fff}.sidebar-light[_ngcontent-%COMP%]     .nav-main-item.open>.nav-main-link-submenu .nav-main-link-icon{color:#000}.sidebar.show.sidebar-collapsed[_ngcontent-%COMP%]     .nav-main .nav-main-item>.nav-main-submenu, .sidebar.show.sidebar-collapsed[_ngcontent-%COMP%]     .remove-in-mini{display:none}.sidebar.show.sidebar-collapsed[_ngcontent-%COMP%]     .hide-in-mini, .sidebar.show.sidebar-collapsed[_ngcontent-%COMP%]     .nav-main .nav-main-heading, .sidebar.show.sidebar-collapsed[_ngcontent-%COMP%]     .nav-main .nav-main-link-name{opacity:0}@media (max-width:991.98px){.sidebar.show[_ngcontent-%COMP%]{width:100%}}@media (min-width:992px){.sidebar.show[_ngcontent-%COMP%]{width:14.375rem}.sidebar.show.sidebar-mini[_ngcontent-%COMP%]{width:3.75rem;overflow-x:hidden;transition:width .28s ease-out}.sidebar.show.sidebar-mini[_ngcontent-%COMP%]   .nav-menu-content[_ngcontent-%COMP%], .sidebar.show.sidebar-mini[_ngcontent-%COMP%]   .nav-menu-header[_ngcontent-%COMP%]{width:14.375rem;transition:width .28s ease-out;will-change:width}.sidebar.show.sidebar-mini[_ngcontent-%COMP%]     .nav-main .nav-main-heading, .sidebar.show.sidebar-mini[_ngcontent-%COMP%]     .nav-main .nav-main-link-name{transition:opacity .28s ease-out}.sidebar.show.sidebar-mini[_ngcontent-%COMP%]:not(:hover)     .nav-main .nav-main-item>.nav-main-submenu, .sidebar.show.sidebar-mini[_ngcontent-%COMP%]:not(:hover)     .remove-in-mini{display:none}.sidebar.show.sidebar-mini[_ngcontent-%COMP%]:not(:hover)     .hide-in-mini, .sidebar.show.sidebar-mini[_ngcontent-%COMP%]:not(:hover)     .nav-main .nav-main-heading, .sidebar.show.sidebar-mini[_ngcontent-%COMP%]:not(:hover)     .nav-main .nav-main-link-name{opacity:0}.sidebar.show.sidebar-mini[_ngcontent-%COMP%]:hover{width:14.375rem}.sidebar.show.sidebar-mini[_ngcontent-%COMP%]:hover   .nav-menu-content[_ngcontent-%COMP%], .sidebar.show.sidebar-mini[_ngcontent-%COMP%]:hover   .nav-menu-header[_ngcontent-%COMP%]{width:100%}}"] });
__decorate([
    Input()
], NavMenuComponent.prototype, "items", void 0);
__decorate([
    Input()
], NavMenuComponent.prototype, "theme", void 0);
__decorate([
    Input()
], NavMenuComponent.prototype, "customScrollbar", void 0);
__decorate([
    Input()
], NavMenuComponent.prototype, "miniMode", void 0);
__decorate([
    Input()
], NavMenuComponent.prototype, "isFixed", void 0);
__decorate([
    Input()
], NavMenuComponent.prototype, "isMiniOnMouseLeave", void 0);
__decorate([
    Input()
], NavMenuComponent.prototype, "filterValue", void 0);

let NavMenuFilterPipe = class NavMenuFilterPipe {
    /**
     * Transform function returns array of items matching search term
     * @param value - menu item to be filtered
     * @param term - search term
     */
    transform(value = [], term) {
        const searchText = term === null || term === void 0 ? void 0 : term.trim();
        if (!searchText) {
            return value;
        }
        return value.filter((item) => this.containsFilterValue(item, searchText));
    }
    containsFilterValue(menuItem, filterValue) {
        var _a;
        return !((_a = menuItem.children) === null || _a === void 0 ? void 0 : _a.length)
            ? menuItem.name.toLowerCase().includes(filterValue.toLowerCase())
            : menuItem.children.some((child) => this.containsFilterValue(child, filterValue));
    }
};
NavMenuFilterPipe.ɵfac = function NavMenuFilterPipe_Factory(t) { return new (t || NavMenuFilterPipe)(); };
NavMenuFilterPipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "uiNgNavMenuFilter", type: NavMenuFilterPipe, pure: true });

let CustomPrimengModule = class CustomPrimengModule {
};
CustomPrimengModule.ɵfac = function CustomPrimengModule_Factory(t) { return new (t || CustomPrimengModule)(); };
CustomPrimengModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: CustomPrimengModule });
CustomPrimengModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ImageOverlayComponent, [{
        type: Component,
        args: [{
                selector: 'ui-ng-image-overlay',
                template: "<div\n\tclass=\"img-container\"\n\t[ngClass]=\"['img-' + imgAnimation, 'img-overlay-' + imgOverlayAnimation]\"\n>\n\t<img class=\"img-fluid img-item\" [src]=\"imgSrc\" [alt]=\"imgName\" />\n\t<div class=\"img-overlay\" [ngClass]=\"'img-overlay-' + imgOverlayBgColor\">\n\t\t<div class=\"img-overlay-content\">\n\t\t\t<ng-content></ng-content>\n\t\t</div>\n\t</div>\n</div>\n",
                styles: [":host{display:block}.img-container{position:relative;z-index:1;display:inline-block;overflow:hidden}.img-container .img-item{transition:transform .25s ease-out;will-change:transform}.img-container .img-overlay{position:absolute;top:-.2rem;right:0;bottom:-.2rem;left:0;z-index:2;display:flex;align-items:center;justify-content:center;visibility:hidden;opacity:0;transition:.3s ease-in;will-change:opacity,transform}.img-container .img-overlay-content{text-align:center}.img-container .img-overlay-black{background-color:rgba(0,0,0,.75)}.img-container .img-overlay-white{background-color:rgba(255,255,255,.9)}.img-container .img-overlay-primary-dark{background-color:rgba(62,74,89,.8)}.img-overlay-slide-top .img-overlay{transform:translateY(100%)}.img-overlay-slide-right .img-overlay{transform:translateX(-100%)}.img-overlay-slide-down .img-overlay{transform:translateY(-100%)}.img-overlay-slide-left .img-overlay{transform:translateX(100%)}.img-overlay-zoom-in .img-overlay{transform:scale(0,0)}.img-overlay-zoom-out .img-overlay{transform:scale(2,2)}.img-overlay-slide-top:hover .img-overlay{transform:translateY(0)}.img-overlay-slide-right:hover .img-overlay{transform:translateX(0)}.img-overlay-slide-down:hover .img-overlay{transform:translateY(0)}.img-overlay-slide-left:hover .img-overlay{transform:translateX(0)}.img-overlay-zoom-in:hover .img-overlay,.img-overlay-zoom-out:hover .img-overlay{transform:scale(1,1)}.img-zoom-in:hover .img-item{transform:scale(1.2,1.2)}.img-rotate-r:hover .img-item{transform:scale(1.4) rotate(8deg)}.img-rotate-l:hover .img-item{transform:scale(1.4) rotate(-8deg)}.img-container:hover .img-overlay{visibility:visible;opacity:1}.img-fluid{max-width:100%;height:auto}img{vertical-align:middle;border-style:none}"]
            }]
    }], function () { return []; }, { imgName: [{
            type: Input
        }], imgOverlayBgColor: [{
            type: Input
        }], imgSrc: [{
            type: Input
        }], imgAnimation: [{
            type: Input
        }], imgOverlayAnimation: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LayoutComponent, [{
        type: Component,
        args: [{
                selector: 'ui-ng-layout',
                template: "<div class=\"layout-page-wrap\" [ngClass]=\"layoutContainerClass\">\n\t<div\n\t\tclass=\"layout-left-container\"\n\t\t*ngIf=\"leftTemplate\"\n\t\t(mouseenter)=\"leftContainerMouseEnter()\"\n\t\t(mouseleave)=\"leftContainerMouseLeave()\"\n\t>\n\t\t<div class=\"layout-left-container-content\">\n\t\t\t<ng-container *ngTemplateOutlet=\"leftTemplate\"></ng-container>\n\t\t</div>\n\t</div>\n\t<div class=\"layout-central-container\">\n\t\t<ng-container *ngTemplateOutlet=\"centralContent\"></ng-container>\n\t</div>\n\t<div\n\t\tclass=\"layout-right-container\"\n\t\t*ngIf=\"rightTemplate\"\n\t\t(mouseenter)=\"rightContainerMouseEnter()\"\n\t\t(mouseleave)=\"rightContainerMouseLeave()\"\n\t>\n\t\t<div class=\"layout-right-container-content\">\n\t\t\t<ng-container *ngTemplateOutlet=\"rightTemplate\"></ng-container>\n\t\t</div>\n\t</div>\n\n\t<div class=\"layout-page-overlay\" (click)=\"closeContainer()\"></div>\n</div>\n\n<ng-template #centralContent>\n\t<div class=\"layout-top-container\" *ngIf=\"topTemplate\">\n\t\t<ng-container *ngTemplateOutlet=\"topTemplate\"></ng-container>\n\t</div>\n\t<div class=\"layout-main-container\">\n\t\t<ng-content></ng-content>\n\t</div>\n\t<div class=\"layout-bottom-container\" *ngIf=\"bottomTemplate\">\n\t\t<ng-container *ngTemplateOutlet=\"bottomTemplate\"></ng-container>\n\t</div>\n</ng-template>\n",
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [""]
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }]; }, { config: [{
            type: Input
        }], scrollBarOptions: [{
            type: Input
        }], topTemplate: [{
            type: Input
        }], leftTemplate: [{
            type: Input
        }], rightTemplate: [{
            type: Input
        }], bottomTemplate: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NavMenuItemComponent, [{
        type: Component,
        args: [{
                selector: 'ui-ng-nav-menu-item',
                template: "<ng-container *ngIf=\"!item.isHeading; else heading\">\n\t<ng-container *ngIf=\"item.children?.length; else finalItem\">\n\t\t<li class=\"nav-main-item\" [class.open]=\"isOpen || expandAll\">\n\t\t\t<a class=\"nav-main-link nav-main-link-submenu\" (click)=\"toggle()\">\n\t\t\t\t<ng-container *ngTemplateOutlet=\"content\"></ng-container>\n\t\t\t</a>\n\t\t\t<ul class=\"nav-main-submenu\" [hidden]=\"!isOpen && !expandAll\">\n\t\t\t\t<ng-container\n\t\t\t\t\t*ngFor=\"\n\t\t\t\t\t\tlet child of item.children\n\t\t\t\t\t\t\t| uiNgNavMenuFilter: filterValue\n\t\t\t\t\t\"\n\t\t\t\t>\n\t\t\t\t\t<ui-ng-nav-menu-item\n\t\t\t\t\t\t[item]=\"child\"\n\t\t\t\t\t\t[filterValue]=\"filterValue\"\n\t\t\t\t\t\t[expandAll]=\"expandAll\"\n\t\t\t\t\t></ui-ng-nav-menu-item>\n\t\t\t\t</ng-container>\n\t\t\t</ul>\n\t\t</li>\n\t</ng-container>\n\n\t<ng-template #finalItem>\n\t\t<li class=\"nav-main-item\">\n\t\t\t<a\n\t\t\t\tclass=\"nav-main-link\"\n\t\t\t\t[class.active]=\"item.isActive\"\n\t\t\t\t[href]=\"item.href\"\n\t\t\t>\n\t\t\t\t<ng-container *ngTemplateOutlet=\"content\"></ng-container>\n\t\t\t</a>\n\t\t</li>\n\t</ng-template>\n\n\t<ng-template #content>\n\t\t<i\n\t\t\t*ngIf=\"item.icon\"\n\t\t\tclass=\"nav-main-link-icon\"\n\t\t\t[ngClass]=\"item.icon\"\n\t\t></i>\n\t\t<span class=\"nav-main-link-name\">{{ item.name }}</span>\n\t</ng-template>\n</ng-container>\n\n<ng-template #heading>\n\t<li class=\"nav-main-heading\">{{ item.name }}</li>\n</ng-template>\n",
                styles: ["@charset \"UTF-8\";:host *,:host :after,:host :before{box-sizing:border-box}.nav-main-heading{padding:1.375rem 1.25rem .375rem;font-weight:600;font-size:.75rem;letter-spacing:.0625rem;text-transform:uppercase}.nav-main-item{display:flex;flex-direction:column}.nav-main-link{position:relative;display:flex;align-items:center;min-height:2.5rem;padding:.625rem 1.25rem;font-size:.875rem;line-height:1rem;text-decoration:none}.nav-main-link .nav-main-link-icon{display:inline-block;flex:0 0 auto;width:1rem;margin-right:.625rem;text-align:center}.nav-main-link .nav-main-link-name{display:inline-block;flex:1 1 auto;max-width:100%}.nav-main-link:hover{cursor:pointer}.nav-main-link.nav-main-link-submenu{padding-right:2rem}.nav-main-link.nav-main-link-submenu:before{position:absolute;top:50%;right:.625rem;display:block;width:1rem;height:1rem;margin-top:-.5rem;font-weight:900;font-size:.75rem;font-family:\"Font Awesome 5 Free\",\"Font Awesome 5 Pro\",serif;line-height:1rem;text-align:center;opacity:.4;transition:opacity .25s ease-out,transform .25s ease-out;content:\"\uF104\"}.nav-main-submenu{height:0;padding-left:2.875rem;overflow:hidden;list-style:none}.nav-main-submenu .nav-main-item{transform:translateX(-.75rem);opacity:0;transition:opacity .25s ease-out,transform .25s ease-out}.nav-main-submenu .nav-main-heading{padding-top:1.25rem;padding-bottom:.25rem;padding-left:0}.nav-main-submenu .nav-main-link{min-height:2.125rem;margin:0;padding-top:.5rem;padding-bottom:.5rem;padding-left:0;font-size:.8125rem}.nav-main-submenu .nav-main-link .active,.nav-main-submenu .nav-main-link:hover{background-color:transparent}.nav-main-submenu .nav-main-submenu{padding-left:.75rem}.nav-main-submenu .nav-main-item.open .nav-main-link{background-color:transparent}.nav-main-item.open>.nav-main-link-submenu:before{transform:rotate(-90deg)}.nav-main-item.open>.nav-main-submenu{height:auto}.nav-main-item.open>.nav-main-submenu .nav-main-item{transform:translateX(0);opacity:1}"]
            }]
    }], function () { return []; }, { setOpenId: [{
            type: Output
        }], item: [{
            type: Input
        }], id: [{
            type: Input
        }], openedId: [{
            type: Input
        }], filterValue: [{
            type: Input
        }], expandAll: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NavMenuComponent, [{
        type: Component,
        args: [{
                selector: 'ui-ng-nav-menu',
                template: "<nav\n\tclass=\"sidebar sidebar-{{ theme }} custom-scrollbar-{{\n\t\tcustomScrollbar ? theme : ''\n\t}}\"\n\t[ngClass]=\"{\n\t\t'sidebar-mini': isMiniModeEnabled(),\n\t\tshow: isShown(),\n\t\t'sidebar-fixed': isFixed,\n\t\t'sidebar-collapsed': isMiniOnMouseLeave\n\t}\"\n>\n\t<div class=\"nav-menu-header\">\n\t\t<ng-content></ng-content>\n\t</div>\n\t<div class=\"nav-menu-content\">\n\t\t<ul class=\"nav-main\">\n\t\t\t<ng-container\n\t\t\t\t*ngFor=\"\n\t\t\t\t\tlet item of items | uiNgNavMenuFilter: filterValue;\n\t\t\t\t\tlet i = index\n\t\t\t\t\"\n\t\t\t>\n\t\t\t\t<ui-ng-nav-menu-item\n\t\t\t\t\t[item]=\"item\"\n\t\t\t\t\t[id]=\"i + 1\"\n\t\t\t\t\t[openedId]=\"openedId\"\n\t\t\t\t\t[filterValue]=\"filterValue\"\n\t\t\t\t\t[expandAll]=\"expandAll\"\n\t\t\t\t\t(setOpenId)=\"setOpenedId($event)\"\n\t\t\t\t></ui-ng-nav-menu-item>\n\t\t\t</ng-container>\n\t\t</ul>\n\t</div>\n</nav>\n",
                styles: [":host{width:100%;height:100%}:host *,:host :after,:host :before{box-sizing:border-box}.sidebar{width:0;height:100%;overflow-y:auto;border:none;box-shadow:none;transition:width .28s ease-out;will-change:width;-ms-scroll-chaining:none;overscroll-behavior:contain}.sidebar.sidebar-fixed{position:fixed;top:0;bottom:0;left:0;z-index:1032}.nav-menu-header{width:100%;margin:0 auto}.nav-menu-content{width:100%;margin:0 auto;padding:0 1.25rem 1.25rem;overflow-x:hidden}.nav-main{margin:0 -1.25rem;padding:0;list-style:none}.sidebar-dark{color:#ebebeb;background-color:#002b49}.sidebar-dark ::ng-deep .nav-main-heading{color:rgba(255,255,255,.4)}.sidebar-dark ::ng-deep .nav-main-link{color:rgba(255,255,255,.5)}.sidebar-dark ::ng-deep .nav-main-link .nav-main-link-icon{color:rgba(255,255,255,.2)}.sidebar-dark ::ng-deep .nav-main-link.active{color:#fff}.sidebar-dark ::ng-deep .nav-main-item.open>.nav-main-link-submenu{color:#fff}.sidebar-light{color:#575757;background-color:#fff}.sidebar-light ::ng-deep .nav-main-heading{color:#979797}.sidebar-light ::ng-deep .nav-main-link{color:#575757}.sidebar-light ::ng-deep .nav-main-link .nav-main-link-icon{color:#b0b0b0}.sidebar-light ::ng-deep .nav-main-link.active{color:#000}.sidebar-light ::ng-deep .nav-main-item.open>.nav-main-link-submenu{color:#000}.sidebar-dark ::ng-deep .nav-main-submenu{background-color:rgba(0,0,0,.15)}.sidebar-dark ::ng-deep .nav-main-submenu .nav-main-link{color:rgba(255,255,255,.4)}.sidebar-dark ::ng-deep .nav-main-submenu .nav-main-link.active{color:#fff}.sidebar-light ::ng-deep .nav-main-submenu{background-color:rgba(0,0,0,.02)}.sidebar-light ::ng-deep .nav-main-submenu .nav-main-link{color:#717171}.sidebar-light ::ng-deep .nav-main-submenu .nav-main-link.active{color:#000}.sidebar-dark ::ng-deep .nav-main-link.active .nav-main-link-icon{color:#fff}.sidebar-light ::ng-deep .nav-main-link.active .nav-main-link-icon{color:#000}.sidebar-dark ::ng-deep .nav-main-link:hover{background-color:rgba(0,0,0,.2)}.sidebar-dark ::ng-deep .nav-main-link:hover>.nav-main-link-icon{color:#fff}.sidebar-light ::ng-deep .nav-main-link:hover{color:#575757;background-color:#f9f9f9}.sidebar-light ::ng-deep .nav-main-link:hover>.nav-main-link-icon{color:#000}.sidebar-dark ::ng-deep .nav-main-submenu .nav-main-link:hover{color:#fff}.sidebar-light ::ng-deep .nav-main-submenu .nav-main-link:hover{color:#000}.sidebar-dark ::ng-deep .nav-main-item.open>.nav-main-link-submenu .nav-main-link-icon{color:#fff}.sidebar-light ::ng-deep .nav-main-item.open>.nav-main-link-submenu .nav-main-link-icon{color:#000}.sidebar.show.sidebar-collapsed ::ng-deep .nav-main .nav-main-item>.nav-main-submenu,.sidebar.show.sidebar-collapsed ::ng-deep .remove-in-mini{display:none}.sidebar.show.sidebar-collapsed ::ng-deep .hide-in-mini,.sidebar.show.sidebar-collapsed ::ng-deep .nav-main .nav-main-heading,.sidebar.show.sidebar-collapsed ::ng-deep .nav-main .nav-main-link-name{opacity:0}@media (max-width:991.98px){.sidebar.show{width:100%}}@media (min-width:992px){.sidebar.show{width:14.375rem}.sidebar.show.sidebar-mini{width:3.75rem;overflow-x:hidden;transition:width .28s ease-out}.sidebar.show.sidebar-mini .nav-menu-content,.sidebar.show.sidebar-mini .nav-menu-header{width:14.375rem;transition:width .28s ease-out;will-change:width}.sidebar.show.sidebar-mini ::ng-deep .nav-main .nav-main-heading,.sidebar.show.sidebar-mini ::ng-deep .nav-main .nav-main-link-name{transition:opacity .28s ease-out}.sidebar.show.sidebar-mini:not(:hover) ::ng-deep .nav-main .nav-main-item>.nav-main-submenu,.sidebar.show.sidebar-mini:not(:hover) ::ng-deep .remove-in-mini{display:none}.sidebar.show.sidebar-mini:not(:hover) ::ng-deep .hide-in-mini,.sidebar.show.sidebar-mini:not(:hover) ::ng-deep .nav-main .nav-main-heading,.sidebar.show.sidebar-mini:not(:hover) ::ng-deep .nav-main .nav-main-link-name{opacity:0}.sidebar.show.sidebar-mini:hover{width:14.375rem}.sidebar.show.sidebar-mini:hover .nav-menu-content,.sidebar.show.sidebar-mini:hover .nav-menu-header{width:100%}}"]
            }]
    }], function () { return []; }, { items: [{
            type: Input
        }], theme: [{
            type: Input
        }], customScrollbar: [{
            type: Input
        }], miniMode: [{
            type: Input
        }], isFixed: [{
            type: Input
        }], isMiniOnMouseLeave: [{
            type: Input
        }], filterValue: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NavMenuFilterPipe, [{
        type: Pipe,
        args: [{
                name: 'uiNgNavMenuFilter'
            }]
    }], null, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CustomPrimengModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    ImageOverlayComponent,
                    NavMenuComponent,
                    NavMenuItemComponent,
                    LayoutComponent,
                    NavMenuFilterPipe,
                ],
                imports: [CommonModule],
                exports: [ImageOverlayComponent, NavMenuComponent, LayoutComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CustomPrimengModule, { declarations: function () { return [ImageOverlayComponent, NavMenuComponent, NavMenuItemComponent, LayoutComponent, NavMenuFilterPipe]; }, imports: function () { return [CommonModule]; }, exports: function () { return [ImageOverlayComponent, NavMenuComponent, LayoutComponent]; } }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { CustomPrimengModule, ImageOverlayComponent, LayoutComponent, NavMenuComponent, layoutPanelPosition, NavMenuItemComponent as ɵa, NavMenuFilterPipe as ɵb };

